// extracted by mini-css-extract-plugin
export default {"artistArtwork":"LwqjJzmayGIVQi7YRMDv","artistArtworkStatus":"HWUKinABQLk_qWVHL3Po"};